module.exports = __webpack_public_path__ + "./images/success-icon-2.46735ad22267bf4aec5712e305543944.png";